import _                   from 'lodash';
import { applyMiddleware } from 'redux';
import thunkMiddleware     from 'redux-thunk';
import promiseMiddleware   from 'redux-promise-middleware';

const isPromise     = obj => _.isObject(obj) && _.isFunction(obj.then);
const swallowErrors = ['NotFoundError', 'BadRequestError', 'ForbiddenError', 'PreconditionFailed'];

// swallows errors for all rejected promise-actions - these are handled in reducers
export function swallowErrorsMiddleware() {
  return next => action => {
    if (!isPromise(action.payload)) {
      return next(action);
    }

    return next(action).catch(function(error) {
      if (!swallowErrors.includes(error.name)) {
        throw error;
      }
    });
  };
}

export const defaultMiddleware =
  applyMiddleware(thunkMiddleware, swallowErrorsMiddleware, promiseMiddleware);

export class Reducer {
  static initClass() {
    this.prototype.prefix       = '';
    this.prototype.initialState = {};
  }

  constructor() {
    this.dispatch = this.dispatch.bind(this);
  }

  dispatch(state, action, ...args) {
    if (_.isNil(state)) {
      state = this.initialState;
    }

    const prefix = new RegExp('^' + this.prefix + '_?');
    const method = this[_.camelCase(action.type.replace(prefix, ''))];

    if (method) {
      return method.bind(this)(state, action, ...args);
    } else {
      return state;
    }
  }

  static dispatch(state, action, ...args) {
    return (new (this)).dispatch(state, action, ...args);
  }
};

Reducer.initClass()

export function dispatchToProps(actionCreators) {
  return dispatch => _.mapValues(
    actionCreators, creator => (...args) => dispatch(creator(...args))
  );
}
